<div class="content-box">
    <div class="content-box__base-information">
        <div class="content-box__base-information--title"
             [ngClass]="{'content-box__base-information--title--red' : chartData[1].value <= 0}">
            {{title}}
        </div>
        <div class="content-box__base-information--description">
            {{description}}
        </div>
    </div>
    <div class="content-box__doughnut">
        <app-doughnut [descriptionText]="doughnutDescription"
                      [chartData]="chartData"
                      [height]="110"
                      [width]="110">
        </app-doughnut>
    </div>
</div>